import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  computed,
  effect,
  inject,
  input,
} from '@angular/core';
import { AccountUtilsService } from '@core/services/account-utils.service';

@Directive({
  selector: '[appRequirePermission]',
  standalone: true,
})
export class RequirePermissionDirective {
  private view = inject(ViewContainerRef);
  private template = inject<TemplateRef<any>>(TemplateRef);
  private accountUtilsService = inject(AccountUtilsService);

  public readonly appRequirePermission = input<string | string[]>();

  private readonly visible = computed(() => {
    const required = this.appRequirePermission();

    if (!required || required.length === 0) {
      return true;
    }

    return this.accountUtilsService.hasRequiredPermission(required);
  });

  constructor() {
    effect(() => {
      this.view.clear();

      if (this.visible()) {
        this.view.createEmbeddedView(this.template);
      }
    });
  }
}
